var map = {
	"./0.jpg": "3f56",
	"./1.jpg": "9271",
	"./2.jpg": "c27d",
	"./3.jpg": "c1a8",
	"./4.jpg": "c676",
	"./5.jpg": "7211",
	"./6.jpg": "bf33",
	"./7.jpg": "05ba",
	"./8.jpg": "619d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "304c";